import WithDirection from "@iso/lib/helpers/rtl";
import styled from "styled-components";
import { palette } from "styled-theme";

export const IFrameContainer = styled.div`
  width: 100%;
`;

export const IFrame = styled.iframe`
  border: 0;
  height: 790px;
  width: 100%;
`;

const SignUpStyleWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 70px);
  display: flex;
  
  
  li {
    align-items: center;
  }
  
  .valid span {
    color: #00ABAB;
  }

  .invalid span {
    color: #E16408;
  }

  .error span {
    color: #e16408;
  }

  .isoSignUpContentWrapper {
    width: 35%;
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
    overflow-y: auto;
    z-index: 10;
    position: relative;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.05);
  }

  .isoSignUpContent {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px 50px;
    position: relative;
    background-color: #ffffff;
    h3 {
      margin: 0 0 15px;
    }
    .logo-signin {
      width: 200px;
      margin: auto;
      height: auto;
    }

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: 70px 20px;
    }

    .checklist {
      vertical-align: center !important;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      margin-bottom: 50px;
      justify-content: center;
      flex-shrink: 0;

      a {
        font-size: 24px;
        font-weight: 300;
        line-height: 1;
        text-transform: uppercase;
        color: ${palette("secondary", 2)};
      }
    }

    .isoSignUpForm {
      width: 100%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;

      }

      .isoHelperWrapper {
        margin-top: 35px;
        flex-direction: column;
      }

      .isoForgotPass {
        font-size: 12px;
        color: ${palette("text", 2)};
        margin-bottom: 10px;

        &:hover {
          color: ${palette("primary", 0)};
        }
      
      }
    }
  }
`;

export default WithDirection(SignUpStyleWrapper);
